import { Serializable } from "../../../tendercuts/models/base";

/**
 * Get store information(phone numbers)
 */
export class StoreNotification implements Serializable<StoreNotification> {
    
  public phone: string;
  public label: string;

  constructor() {}

  deserialize(input) {
    this.phone = input.phone;
    this.label = input.label;

    return this;
  }

  get phoneNumber() {
    return this.phone;
  }
}
